import { serializeJsonLd } from "@/lib/safeJsonLd";
import { Helmet } from "react-helmet-async";
import { brand } from "@/config/brand";
import { business } from "@/config/business";

/**
 * Global JSON-LD schemas injected on every page:
 * - Organization
 * - WebSite (with SearchAction for sitelinks search box)
 */
const GlobalJsonLd = () => {
  const origin = typeof window !== "undefined" ? window.location.origin : `https://${brand.domain}`;

  const organization = {
    "@context": "https://schema.org",
    "@type": "OnlineStore",
    "@id": `${origin}/#organization`,
    name: brand.name,
    legalName: business.legalName,
    url: origin,
    logo: `${origin}/pwa-512x512.png`,
    image: `${origin}/pwa-512x512.png`,
    description: brand.description,
    email: business.email,
    telephone: business.phoneE164,
    ...(business.taxId ? { taxID: business.taxId, vatID: business.taxId } : {}),
    currenciesAccepted: "ILS",
    paymentAccepted: "כרטיס אשראי, PayPal",
    areaServed: { "@type": "Country", name: "Israel" },
    address: {
      "@type": "PostalAddress",
      streetAddress: business.street,
      addressLocality: business.city,
      addressCountry: business.country,
      ...(business.postalCode ? { postalCode: business.postalCode } : {}),
    },
    contactPoint: [
      {
        "@type": "ContactPoint",
        contactType: "customer service",
        telephone: business.phoneE164,
        email: business.email,
        url: `${origin}/צור-קשר`,
        areaServed: "IL",
        availableLanguage: ["Hebrew", "English"],
      },
    ],
    hasMerchantReturnPolicy: {
      "@type": "MerchantReturnPolicy",
      applicableCountry: "IL",
      returnPolicyCategory: "https://schema.org/MerchantReturnFiniteReturnWindow",
      merchantReturnDays: business.returnDays,
      returnMethod: "https://schema.org/ReturnByMail",
      returnFees: "https://schema.org/ReturnShippingFees",
      merchantReturnLink: `${origin}/מדיניות-החזרות`,
    },
    sameAs: business.social.map((s) => s.url),
  };


  const webSite = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "@id": `${origin}/#website`,
    name: brand.name,
    url: origin,
    description: brand.description,
    inLanguage: "he",
    publisher: { "@id": `${origin}/#organization` },
    potentialAction: {
      "@type": "SearchAction",
      target: {
        "@type": "EntryPoint",
        urlTemplate: `${origin}/?search={search_term_string}`,
      },
      "query-input": "required name=search_term_string",
    },
  };

  return (
    <Helmet>
      <script type="application/ld+json">{serializeJsonLd(organization)}</script>
      <script type="application/ld+json">{serializeJsonLd(webSite)}</script>
    </Helmet>
  );
};

export default GlobalJsonLd;
